module.exports = __webpack_public_path__ + "img/trophy9.png";